/**
 * @generated SignedSource<<4860ee2b1566f668c06a3e2514015010>>
 * @relayHash 004ba98fd6cba0d473c3f331a3521728
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/489.0.0-2024-11-15T08:51:08.280Z/GetHelpZendeskArticlesSearchRefetchQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskArticlesSearchRefetchQuery$variables = {
  query?: string | null;
};
export type GetHelpZendeskArticlesSearchRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskArticlesSearch_viewer">;
  };
};
export type GetHelpZendeskArticlesSearchRefetchQuery = {
  response: GetHelpZendeskArticlesSearchRefetchQuery$data;
  variables: GetHelpZendeskArticlesSearchRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetHelpZendeskArticlesSearchRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskArticlesSearch_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetHelpZendeskArticlesSearchRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact1stdibsZendeskArticles",
            "kind": "LinkedField",
            "name": "zendeskArticles",
            "plural": false,
            "selections": [
              {
                "alias": "articlesSearch",
                "args": (v1/*: any*/),
                "concreteType": "ZendeskArticle",
                "kind": "LinkedField",
                "name": "articles",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/489.0.0-2024-11-15T08:51:08.280Z/GetHelpZendeskArticlesSearchRefetchQuery",
    "metadata": {},
    "name": "GetHelpZendeskArticlesSearchRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "65f3407def2643c13b21bc4abd570c2b";

export default node;
